import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import queryString from "query-string";
import { find, snakeCase } from "lodash";

import { useLocationContext } from "~/context/LocationContext";

import { CODE_NAME, ENGLISH_CODE } from "~/utilities/translations";

const withTranslationProps = (Component, Translator) => {
    return (props) => {
        const urlPermutations = props?.pageContext?.urlPermutations ?? [];
        const pageLanguageCode = props?.pageContext?.languageCode ?? "";

        const { wp } = useStaticQuery(graphql`
            query {
                wp {
                    templateStringsTranslations {
                        registeredString
                        domain
                        name
                        translations {
                            languageCode
                            translatedString
                        }
                    }
                    tableHeaders {
                        labels {
                            label
                            languageCode
                        }
                        value
                    }
                    languages {
                        code
                        native_name
                        default_locale
                    }
                }
            }
        `);

        const { location } = useLocationContext();

        const validateCode = (activeCode) => {
            return (
                find(wp?.languages, (language) => {
                    return (
                        language.code === activeCode ||
                        snakeCase(language.default_locale) ===
                            snakeCase(activeCode)
                    );
                })?.code || ENGLISH_CODE
            );
        };

        const getActiveCode = () => {
            const param = queryString.parse(location.search)[CODE_NAME];
            const isEnglish = pageLanguageCode === ENGLISH_CODE;
            const pageCode = isEnglish ? "" : pageLanguageCode;
            const activeCode = pageCode || param || ENGLISH_CODE;

            return validateCode(activeCode);
        };

        let translator = null;

        const translationProps = {
            location,
            urlPermutations,
            activeCode: getActiveCode(),
            orderMatrix: wp?.tableHeaders ?? [],
            templateStrings: wp?.templateStringsTranslations ?? [],
            englishCode: ENGLISH_CODE,
            activeLanguages: wp?.languages || [],
            codeName: CODE_NAME,
        };

        if (Translator) {
            translator = new Translator({
                ...props,
                translationProps,
            });
        }

        return (
            <Component
                {...{
                    ...props,
                    translationProps,
                    translator,
                }}
            />
        );
    };
};

export default withTranslationProps;
